export enum CUSTOMER_STATUS_ENUM {
  Active = 'Activo',
  Inactive = 'Baja'
}

export enum CUSTOMER_STATUS_COLOR_ENUM {
  Active = 'primary',
  Inactive = 'danger'
}

//* Estado de conversión del funnel Omnicanal (badge en la pestaña Prospectos).
export enum CONVERSION_STATUS_ENUM {
  in_funnel = 'En funnel',
  in_origination = 'En originación',
  won = 'Ganado',
  lost = 'Perdido'
}

export enum CONVERSION_STATUS_COLOR_ENUM {
  in_funnel = 'warning',
  in_origination = 'info',
  won = 'success',
  lost = 'danger'
}
